import React, { Component, Suspense } from "react";
import _ from "lodash";
import Loader from "../../../Global/Loader";
import axios from "axios";
import { Services } from "../../../../repositories/clients/Services";
import { Icon } from "semantic-ui-react";
import { connect } from "react-redux";
import { Tab } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import SumaryDetail from "./components/general";
// import Events from "./components/Events";
import Document from "./components/Documents";
import queryString from "query-string";
import { withNamespaces } from "react-i18next";
import RepositoryFactory from "../../../../repositories/RepositoryFactory";
import { validateIdParams } from "../../../utils/regularExpressionValidation";
import createModal from "../../Components/ModalV2";
import { openNotification } from "../../Components/Notification";

import "./styles/styles.scss";

const Comments = React.lazy(() => import("../../Components/Comments"));
const AllComments = React.lazy(() =>
  import("../../Components/Comments/AllComment")
);
const PurchaseOrderRepository = RepositoryFactory.get("SupplierManagement");

class PurchaseOrderDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalSuccess: false,
      typeModal: 'success',
      isMobil: false,
      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : "[0]",
      scrollLine: true,
      tabActive: 0,
      rolId: this.props._rolId,
      userId: this.props._user,
      AllcommentsData: [],
      createFormsData: [],
      isEdit: false,
      createForms: [],
      poInfo: {},
      purchaseOrderId: this.props.match ? this.props.match.params.id : -1,
      info: {},
      allSteps: [],
      newStepsAereoM: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 15,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      newStepsTerrestre: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 16,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      infoEmbarque: {},
      loadingInfo: true,
      isEditing: false,
      tablaClientes: "",
      commentsData: [],
      users: [],
      catalogsData: [
        {
          ComTypeId: 1,
          ModuleId: 1,
          ComType: "Supplier Follow Up",
          value: 1,
          label: "Supplier Follow Up",
        },
        {
          ComTypeId: 2,
          ModuleId: 1,
          ComType: "Order Quality",
          value: 2,
          label: "Order Quality",
        },
        {
          ComTypeId: 3,
          ModuleId: 1,
          ComType: "Order Quantities",
          value: 3,
          label: "Order Quantities",
        },
        {
          ComTypeId: 10,
          ModuleId: 1,
          ComType: "Other",
          value: 10,
          label: "Other",
        },
      ],
    };
  }

  componentDidMount = async () => {
    this.validateParamId();
    const details = navigator.userAgent;
    const regexp = /android|iphone|kindle|ipad/i;
    const isMobileDevice = regexp.test(details);
    this.setState({
      isMobil: isMobileDevice,
    });
    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;
    if (isNotify.nofify) {
      notifyActiveComment = true;
    }
    await this.getPurchaseOrder(notifyActiveComment);
    this.getComments(notifyActiveComment);
  };

  validateParamId = () => {
    const { purchaseOrderId } = this.state;
    const idValidate = validateIdParams(purchaseOrderId);
    if (!idValidate) {
      openNotification('error', this.props.t("Data_entered_is_invalid"));
      setTimeout(() => {
        this.props.history.push("/po-management");
      }, 2000);
      return;
    }
  };

  getComments = async (NewComments, notifyActiveComment) => {

    try {
      let { CustomerId, POId } = this.state.poInfo;
      let moduleId = 10;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const { lng } = this.props;

      const params = new URLSearchParams({
        rowid: POId,
        moduleid: moduleId,
        general: false,
        zona: timezone,
        lang: lng
      });

      const response = await axios.get(`${Services.PURCHASE_ORDER.path}supplier-management/orders-coments?${params.toString()}`);
      const comentario = response.data.data.Comment;
      const AllcommentsData = response.data.data.CommentGeneral;
      this.setState({
        AllcommentsData: AllcommentsData,
        scrollLine: NewComments,
      });
      this.getUserMenciones(comentario, CustomerId, POId, this.state.poInfo, AllcommentsData);

      if (notifyActiveComment) {
        openNotification('success', notifyActiveComment);
      }
    } catch (error) {
      console.log("🚀 ~ PurchaseOrderDetail ~ getComments= ~ error:", error)
    }
  };

  getUserMenciones = async (comentario, CustomerId, ShipmentId, item) => {
    let { userId } = this.state;

    try {
      const response = await axios.get(
        `${Services.PURCHASE_ORDER.path}supplier-management/user-mension?CustomerId=${encodeURIComponent(CustomerId)}&user=${encodeURIComponent(userId)}`
      );

      this.setState({
        commentsData: comentario,
        users: response.data.data,
        rowid: ShipmentId,
        itemCommenSelect: item,
        loadercomments: false,
      });

    } catch (error) {
      console.error("Error al obtener menciones de usuario:", error);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;
    const newProp = nextProps.match.params.id || this.props.match.params.id;

    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        if (isNotify.nofify) {
          notifyActiveComment = true;
          this.setState(
            {
              purchaseOrderId: newProp,
              loadingInfo: true,
            },
            () => {
              this.getPurchaseOrder(notifyActiveComment);
              this.getComments(notifyActiveComment);
            }
          );
        }
      }
    );
  };

  getPurchaseOrder = async (notifyActiveComment) => {
    const { tempInfo, purchaseOrderId, userId, rolId } = this.state;
    const { lng, history, t } = this.props;

    try {
      const { data } = await axios.get(
        `${Services.PURCHASE_ORDER.path}supplier-management/order-detail/${purchaseOrderId}?user=${userId}&lang=${lng}&rolId=${rolId}`
      );

      if (!data?.data) throw new Error("No data returned");

      const poInfo = {
        ...data.data,
        pickupAddressConcatenated: `${data.data.PickupAddress}, ${data.data.OriginZipCode}`,
        DeliveryAddressPOConcatenated: `${data.data.DeliveryAddressPO}, ${data.data.DestinationZipCode}`,
      };

      this.setState(
        {
          poInfo,
          tempInfo,
          loadingInfo: false,
          tabActive: notifyActiveComment ? 1 : 0,
        },
      );
    } catch (error) {
      console.log("🚀 ~ PurchaseOrderDetail ~ getPurchaseOrder= ~ error:", error)
      openNotification("error", t("Data_entered_is_invalid"));
      setTimeout(() => history.push("/supplier-management"), 2000);
    }
  };


  actualiza = async (newPO) => {
    const { purchaseOrderId, userId } = this.state;
    this.setState({ isEditing: false, loadingInfo: true }, async () => {
      try {
        const updatePO = {
          ...newPO,
          POId: purchaseOrderId,
          UserId: userId,
        };
        await Promise.all([
          PurchaseOrderRepository.updatePO(updatePO),
          PurchaseOrderRepository.updatePOCustomerEntities(updatePO),
        ]);

        this.setState({ modalSuccess: true, typeModal: 'success', messageModal: this.props.t("purchase_order_successfully_updated") })
        this.getPurchaseOrder();
      } catch (error) {
        console.log("🚀 ~ PurchaseOrderDetail ~ this.setState ~ error:", error)
        this.setState({ modalSuccess: true, typeModal: 'error', messageModal: this.props.t("purchase_order_error_updated"), loadingInfo: false })
      }
    });
  };

  editar = () => {
    const { isEditing } = this.state;
    this.setState({ isEditing: !isEditing });
  };

  showLoad = () => {
    this.setState({ loadingInfo: true });
  };

  finishLoad = () => {
    this.setState({ loadingInfo: false });
  };


  cancelar = () => {
    const { isEditing, tempInfo } = this.state;
    this.setState({
      isEditing: !isEditing,
      info: _.cloneDeep(tempInfo),
    });
  };

  tabChange = (evt, data) => {
    if (data.activeIndex > 0) {
      this.setState({ loadingInfo: false, isEditing: false });
    }
  };

  newMessage = async (data) => {
    const { purchaseOrderId, userId } = this.state;

    const requestPayload = {
      ...data,
      Rowid: purchaseOrderId,
      UserId: userId,
      ModuleId: 10,
      Mentions: [...new Set(data.Mentions || [])],
    };

    try {
      await axios.post(
        `${Services.PURCHASE_ORDER.path}supplier-management/order-comments/add`,
        requestPayload
      );

      this.getComments(false, this.props.t("comment_successfully_saved"));

    } catch (error) {
      console.error("Error al guardar comentario:", error);
      openNotification('error', "Error al mandar el comentario");
    }
  };

  deleteMessage = async (idDelete, toggle) => {
    try {
      await axios.delete(
        `${Services.PURCHASE_ORDER.path}supplier-management/delete-comment/${idDelete}`
      );

      this.getComments(false, this.props.t("comment_successfully_deleted"));
      toggle();

    } catch (error) {
      console.error("Error al eliminar comentario:", error);
      openNotification("error", this.props.t("comment_error_deleting") || "Error al eliminar comentario");
    }
  };


  render() {
    let {
      tabActive,
      loadingInfo,
      isMobil,
      rolId,
      userId,
      commentsData,
      users,
      AllcommentsData,
      modalSuccess,
      messageModal
    } = this.state;

    if (loadingInfo) return <Loader />;

    return (
      <ContainerWrapper>
        <div className="content-heading">
          <span className="icon-supplier-management-2 icon-header" />
          {this.props.t("supplier_management_page_title")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/supplier-management")}
              />
            </Icon.Group>
            <span className="label-back" onClick={() => this.props.history.push("/supplier-management")}>
              {this.props.t("back")}
            </span>
          </div>
        </div>
        <Tab
          menu={{ secondary: true, pointing: true, className: 'custom-tab-menu' }}
          onTabChange={(_event, data) => {
            this.setState(
              { tabActive: data.activeIndex },
              () => this.tabChange
            );
          }}
          activeIndex={tabActive}
          panes={[
            {
              menuItem: this.props.t("summary"),
              render: () => (
                <Suspense fallback={<div>Loading...</div>}>
                  <SumaryDetail
                    rolId={this.props._rolId}
                    steps={this.state.steps}
                    userid={this.props._user}
                    cancelar={this.cancelar}
                    actualiza={this.actualiza}
                    poInfo={this.state.poInfo}
                    isMobil={isMobil}
                    getPO={this.getPurchaseOrder}
                    getComments={this.getComments}
                  />
                </Suspense>
              ),
            },
            {
              menuItem: this.props.t("comments"),
              render: () => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ContainerWrapper>
                    <div class="row">
                      <div class="col-xs-12 col-md-6 col-lg-6">
                        <legend className="legendEuroBold">
                          {this.state.info ? this.state.info.RefCustomer : ""}
                        </legend>
                        <Comments
                          scrollLine={this.state.scrollLine}
                          rolId={rolId}
                          userId={userId}
                          data={commentsData}
                          catalogs={users}
                          funtionNewMessage={this.newMessage}
                          funtionDeleteMessage={this.deleteMessage}
                        />
                      </div>
                    </div>
                  </ContainerWrapper>
                </Suspense>
              ),
            },
            {
              menuItem: this.props.t("documents"),
              render: () => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ContainerWrapper>
                    <Document
                      _rolId={this.props._rolId}
                      data={this.state.info}
                      id={this.state.info.ServiceOrderId}
                      _user={this.props._user}
                      isMobil={isMobil}
                      poInfo={this.state.poInfo}
                    ></Document>{" "}
                  </ContainerWrapper>{" "}
                </Suspense>
              ),
            },
          ]}
        />
        {createModal({
          isModalOpen: modalSuccess,
          type: 'success',
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{messageModal}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: "Ok",
              onClick: () => this.setState({ modalSuccess: false }),
              type: "primary",
            }
          ],
          onCancel: () => this.setState({ modalSuccess: false })
        })}
      </ContainerWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderDetail))
);
